module.exports = __webpack_public_path__ + "img/labor_day_card_clearance_img_tablet_v2.4ed5847.png";